import {
  getRatingCodesSuccess,
  getRatingCodesFailure,
  GET_RATING_CODES_REQUEST,
}                               from 'Redux/Action';
import { ofType }               from 'redux-observable';
import { from, of }             from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

export function getRatingCodesEpic(action$, store$, { ProcessStatementRepository }) {
  return action$.pipe(ofType(GET_RATING_CODES_REQUEST), mergeMap((action) => {
    return from(ProcessStatementRepository.getRatingCodes()).pipe(mergeMap(({ ratingCodes }) => {
      return from([
        getRatingCodesSuccess({ ratingCodes })
      ]);
    }), catchError(error => of(getRatingCodesFailure({ error, request: action }))));
  }));
}
